export const ADD_Data = 'ADD Data'

export const addData = (payload) => ({type: ADD_Data, payload: payload})